import React, { useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'

import RadioGroup from '../../components/customer-form/radioGroup'

import { navigateToRoute } from '../utils'
import { appBasePath } from '../../../utils/appBasePath'
import useTranslation from '../../../utils/translation'
import {
  Heading,
  SubHeading,
  Box,
  Details,
  Link,
  ConfirmContainer,
  RadioGroupContainer,
  Tooltip,
  TooltipHeading,
  TooltipText,
  CaretContainer,
  Caret,
  BackLink,
  StyledTextarea,
  getFirstName,
  useCancelStep2Submit,
  CancelStep2LoadingOverlay,
} from './CancelStep2Shared'

/**
 * Legacy cancellation reasons only (no CMS cancellation questions).
 * When pageContent has cancellationQuestionsForCustomer or cancellationQuestionsForDesigner,
 * CancelPage renders CancelStep2Extra instead.
 */
const CancelStep2 = ({ appointment }) => {
  const t = useTranslation('cancel.step2')
  const history = useHistory()
  const store = new URLSearchParams(window.location.search).get('store')
  const isStore = !!store

  const [cancellationReason, setCancellationReason] = useState('')
  const [showTooltip, setShowtooltip] = useState(false)
  const [otherReasonText, setOtherReasonText] = useState('')

  const { runCancel, loading } = useCancelStep2Submit({ appointment, isStore })

  const reason = useMemo(() => {
    if (!cancellationReason) return ''
    if (cancellationReason === 'OtherReason') {
      return otherReasonText.trim()
    }
    return cancellationReason
  }, [cancellationReason, otherReasonText])

  const cancel = () => {
    runCancel(reason)
  }

  const onReasonChange = (e) => {
    setCancellationReason(e.target.value)
    setShowtooltip(e.target.value === 'NoLongerAvailable')
  }
  const onOtherReasonChange = (e) => {
    setOtherReasonText(e.target.value)
  }

  const generateOptions = () => {
    const reasons = [
      { key: 'reason1', value: 'NoLongerAvailable' },
      { key: 'reason2', value: 'ChangedMind' },
      { key: 'reason3', value: 'WentElsewhere' },
      { key: 'reason4', value: 'OtherReason' },
    ]

    return reasons.reduce((options, reasonOption) => {
      const label = t(`${isStore ? 'store-' : ''}${reasonOption.key}`)
      if (label) {
        options.push({ value: reasonOption.value, label })
      }
      return options
    }, [])
  }

  return (
    <>
      <Heading>
        {appointment &&
          t('heading', { name: getFirstName(appointment.customerName) })}
      </Heading>
      <Box onClick={() => setShowtooltip(false)}>
        <Details cancellationReason={cancellationReason}>
          <SubHeading>{t('subHeading')}</SubHeading>
          <RadioGroupContainer>
            <RadioGroup options={generateOptions()} onChange={onReasonChange} />
            {cancellationReason === 'OtherReason' && (
              <StyledTextarea
                placeholder={t('otherReasonPlaceholder')}
                value={otherReasonText}
                onChange={onOtherReasonChange}
              />
            )}
            {showTooltip && (
              <Tooltip
                onClick={() =>
                  navigateToRoute(
                    `${appBasePath}amend/${appointment.id}`,
                    history
                  )
                }
              >
                <TooltipHeading>{t('tooltip-heading')}</TooltipHeading>
                <TooltipText
                  dangerouslySetInnerHTML={{
                    __html: t('tooltip-text'),
                  }}
                />
                <CaretContainer>
                  <Caret />
                </CaretContainer>
              </Tooltip>
            )}
          </RadioGroupContainer>
        </Details>
      </Box>
      <ConfirmContainer>
        <Link onClick={cancel} disabled={!reason}>
          {t('buttonText')}
        </Link>

        <BackLink href="/">{t('link')}</BackLink>
      </ConfirmContainer>
      <CancelStep2LoadingOverlay loading={loading} />
    </>
  )
}

export default CancelStep2
